import { render, staticRenderFns } from "./ServerSkuUpdateDialog.vue?vue&type=template&id=3bb5e3c4"
import script from "./ServerSkuUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ServerSkuUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports